<script lang="ts">
export default {
    name: 'BaseInfinityLoading',
};
</script>

<script lang="ts" setup>
import { computed } from 'vue-demi';

import InfinityLoading from './assets/infinity.svg.vue';

interface Props {
    /**
     * colorful为false的时候loading是白色
     */
    colorful?: boolean;
    /**
     * 设置loading颜色
     */
    customColor?: string;
    /**
     * 是不是占整屏
     */
    fullscreen?: boolean;
    /**
     * loading是不是居中
     */
    stayCenter?: boolean;
    /**
     * 描边填充占比
     */
    percent?: number;
    /**
     * loading
     */
    loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    type: 'infinity',
    colorful: true,
    loading: true,
    customColor: '#fe3666',
});

const infinityType = computed(() => ['infinity', props.colorful && 'infinity-colorful']);
const infinityColor = computed(() => (props.customColor && props.colorful ? { color: props.customColor } : {}));
const loadingType = computed(() => [
    props.fullscreen === true && 'loading-fullscreen loading-center',
    props.stayCenter === true && 'loading-center',
]);
</script>

<template>
    <div :class="loadingType">
        <InfinityLoading :class="infinityType" :style="infinityColor" :percent="percent" :loading="loading" />
    </div>
</template>

<style lang="scss" scoped>
$infinity-loading-size: 40px;

.infinity {
    display: inline-block;
    vertical-align: middle;
    width: $infinity-loading-size;
    height: $infinity-loading-size;
    color: #fff;
}
.infinity-colorful {
    color: currentColor;
}
.loading-fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
}
.loading-center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
</style>
